export const PASSWORD_REGEX =
  '^(?=.*[A-Z])(?=.*\\d)(?=.*[!@#$%^&*()\\-_=+{};:,<.>]).{8,}$';

export const TEXT_ONLY_REGEX = '^[a-zA-ZÀ-ÿ\\s-]*$';

export const FRENCH_PHONE_REGEX = '^0[1-9][0-9]{8}$';

export const FRENCH_POSTAL_CODE_REGEX = '^(?:0[1-9]|[1-8]\\d|9[0-8])\\d{3}$';
